export default {
    "label.update_translations_unsuccessful": "",
    "global.no_records": "No records",
    "notifications.rp_has_been_updated": "Gold Residential project has been updated",
    "moduleTitle.files": "Files",
    "label.coordinator": "Coordinator",
    "sidebar.translations_managment": "",
    "table.file": "File",
    "label.report_overview": "",
    "label.parent_agreement": "Printable Parental Consent Form",
    "parentalConsent.i_consent_to_and_understand_that": "6. I consent to and understand that photographs may be taken during the Award activity of the participant participating in this activity and these may be used for promotional purposes. This is provided that the appropriate release is signed by both the participant and the parent/guardian.",
    "parentalConsent.i_understand_that_participants_are_required_to_comply": "12. I understand that the Adventurous Journey Activity is operated under the guidelines in the International Handbook including  any allowable COVID or local adaptations and the Award Unit’s Safety Management Plan. Conduct inconsistent with these guidelines may result in the participant not completing the activity or having to be reassessed or repeat the activity.",
    "table.end_date": "End Date",
    "label.activation_date": "Activation Date",
    "label.report": "",
    "label.award_is_offline": "Award is offline",
    "label.pending_changes": "Pending changes...",
    "errors.min_nights_required": "A minimum of {nights} night(s) is required",
    "label.country": "Country / Territory",
    "notifications.award_leader_has_been_returned": "Award leader has been revised",
    "notifications.participant_has_been_updated": "Participant has been updated",
    "label.phone_number": "Phone Number",
    "roles.aj_assessor": "Adventurous Journey Assessor",
    "notifications.person_state_has_been_changed": "Person state has been changed",
    "pageTitle.dashboard": "Dashboard",
    "moduleTitle.global_payment_method": "Global payment method",
    "label.organization_type": "Organisation Type",
    "button.account_settings": "Account Settings",
    "notifications.contact_has_been_updated": "Contact has been updated",
    "participant.recover_password": "Recover Password",
    "notifications.assessment_request_has_been_sent": "Assessment request has been sent",
    "button.unassign": "",
    "label.start_date": "Start Date",
    "label.assign_labels": "",
    "sidebar.participants": "Participants",
    "roles.coordinator": "Coordinator",
    "label.organization_contact": "Organisation Contact",
    "tabs.customization": "Customisation",
    "sidebar.award_units": "Award Units",
    "button.change_goal": "Change Goal",
    "translationsManagement.selectProject": "",
    "award.rp": "Gold Residential Project",
    "label.size": "Size",
    "label.bulk_action_results": "",
    "notifications.activity_has_been_approved": "Activity has been approved",
    "label.payment_type": "",
    "button.gop_assignment": "",
    "button.resend_assessment_request": "Resend assessment request",
    "notifications.template_has_been_removed": "Template has been removed",
    "button.award_settings": "Award Settings",
    "pageTitle.payment": "Payment",
    "tasks.return_award": "Revise Award",
    "label.link": "link",
    "moduleTitle.award_participant_delete": "",
    "pageTitle.mro_related_contacts": "My Region Office - Related Contacts",
    "pageTitle.my_organization_labels": "",
    "tabs.activity_signoff": "Section Authorisation",
    "table.logs": "Logs",
    "moduleTitle.remove_file": "Remove file?",
    "label.email_confirmed": "Email Confirmed",
    "notifications.activity_has_been_returned": "Activity has been revised",
    "label.note": "Note",
    "button.show": "",
    "tabs.adventurous_journey": "Adventurous Journey",
    "sidebar.my_todolist": "My To Do List",
    "label.here": "here",
    "organisation.change_award_mode": "Change Awards's Mode",
    "table.note_from_al": "Note from Award Leader",
    "label.gender": "Gender",
    "moduleTitle.remove": "Remove?",
    "errors.must_be_less_than": "Must be less than {limit}",
    "button.logout": "Logout",
    "label.no_selected_participants": "No selected participants",
    "button.new_aj_event": "New Adventurous Journey Event",
    "label.employement_status": "Employment Status",
    "tabs.logs": "Logs",
    "tabs.contacts": "Contacts",
    "label.option": "Option",
    "dashboard.charts": "Charts",
    "notifications.rp_has_been_approved": "Gold Residential project has been approved",
    "pageTitle.new_participant": "New Participant",
    "notifications.award_leader_has_been_approved": "Award leader has been approved",
    "moduleTitle.would_you_like_to_remove_leader_training": "Would you like to delete Award Leaders\"s training?",
    "moduleTitle.update_configuration_value": "Update configuration value",
    "table.description": "Description",
    "table.organization": "Organisation",
    "label.youtube": "YouTube",
    "label.author": "Author",
    "table.suitable_for_award_level": "Suitable for Award Level",
    "label.content_update": "Please wait. Updating content...",
    "notifications.new_question_has_been_added": "New question has been added",
    "pageTitle.nao_awards": "National Office - Awards",
    "table.last_name": "Last Name",
    "moduleTitle.adventurous_journey_detail": "Journey Details",
    "Description of the combo box selection in bulk operation panel": {"label.bulk_operations": ""},
    "label.project_location_type": "Project Location Type",
    "label.email_help_award_level": "",
    "label.date": "Date",
    "label.previous_completed_award_place": "Where",
    "button.show_more": "Show more",
    "label.wwc_number": "WWC number",
    "button.filter": "Filter",
    "notifications.rp_has_been_returned": "Gold Residential Project has been revised",
    "pageTitle.residetial_project_assessor_report": "Gold Project - Assessor Report",
    "label.generating": "",
    "moduleTitle.finance_system_data": "Finance System Data",
    "notifications.adventurous_journey_state_has_been_changed": "Adventurous Journey state has been changed",
    "route.levels": "Levels",
    "moduleTitle.activity_leader": "Activity Leader",
    "tasks.approve_event": "Approve Event",
    "tasks.reject_event": "Revise Event",
    "table.region": "Region",
    "pageTitle.nao_award_leaders": "National Office - Award Leaders",
    "errors.must_be_at_least": "Must be at least {min} characters",
    "table.title": "Title",
    "table.last_activity": "Last Activity",
    "tasks.delete_registration": "Delete Registration",
    "table.date_time": "Date / Time",
    "parentalConsent.the_award_operators_are_committed_to_respecting": "14. The Award respects your privacy.  Personal information collected during Award processes is used for the purposes of supporting the participant’s registration with the Award and you as the parent/guardian. If you would like to contact us or access the information held by the Award about the participant please contact the Award National Office.  We can also provide you with a copy of our Privacy Policy.",
    "aj.practice_journey": "Practice Journey",
    "notification.log_has_been_restored": "Activity log has been restored",
    "tabs.my_participants": "My Participants",
    "label.bulk_action_assign_label": "",
    "moduleTitle.supervisor": "Organisation running the Journey",
    "moduleTitle.your_parental_consent": "Your Parental Consent",
    "route.registration_participants": "Registration participants",
    "placeholder.start_typing": "Start typing...",
    "tasks.approve_award": "Approve Award",
    "route.registrations": "Registrations",
    "button.add_activity": "Add Activity",
    "notifications.aj_event_has_been_created": "Adventurous Journey event has been created",
    "states.supervisor_approval": "Assessor Approval",
    "label.description": "Description",
    "button.leave_anyway": "Leave anyway",
    "tabs.registrations": "Registrations",
    "states.leader_signoff": "",
    "moduleTitle.forbidden": "",
    "notifications.translations_has_been_updated.button": "",
    "pageTitle.nao_registration": "National Office - Registration",
    "pageTitle.mro_logs": "My Region Office - Logs",
    "meta.page_not_found": "Page not found",
    "label.bulk_action_unsuccessful": "",
    "global.days": "days",
    "table.review": "Review",
    "table.as_assessor_for": "As assessor for",
    "roles.if_staff_statistical_user": "IF Statistical User",
    "table.levels": "Levels",
    "label.suitable_for_level": "Suitable for Level",
    "pageTitle.leaders": "Leaders",
    "moduleTitle.send_test_email": "Send Test Email",
    "pageTitle.tasks_removed_registration": "Removed Participant Registrations",
    "label.you_will_be_forced_to_login_again_after_change": "You will be forced to login again after change",
    "table.recent_updates": "",
    "pageTitle.tasks_activity_signoffs": "Section Authorisation",
    "pageTitle.payments": "Payments",
    "global.nights": "nights",
    "label.blank_any_level": "",
    "button.view_section": "",
    "moduleTitle.select_organization": "Select organisation",
    "pageTitle.manual_data_import": "",
    "button.upload_files": "Upload Files",
    "label.migrated_contact_email": "Migrated Contact Email",
    "label.for_award_unit": "For Award Unit",
    "label.aj_template_note": "Template note",
    "table.last_log_added": "",
    "button.view_participant": "From Participant",
    "label.please_comment_on_the_participants": "Please comment on the participants improvement/performance/commitment",
    "label.consent_already_given_login": "Consent was already given. Please login as your child.",
    "participant.level_start_date": "{value} Start Date",
    "sidebar.my_region_office": "My Regional Office",
    "states.section_signoff": "Section Authorisation",
    "moduleTitle.assessor_details": "Assessor Details",
    "moduleTitle.adventurous_journey_settings": "Adventurous Journey Settings",
    "moduleTitle.note_from_al": "Note from Award Leader",
    "button.add_role": "Add Role",
    "table.run": "Run",
    "states.change_to_state_warning_missing_assessment": "",
    "label.user_app_guide_leader": "User app guide - Award Leader",
    "tabs.section_approval": "Section Approval",
    "roles.award_verifier": "Award Verifier",
    "tabs.activity_approval": "Activity Approval",
    "logs.add_log": "Add Log",
    "tabs.award": "Award",
    "notifications.this_role_has_read_only_persmission": "This role has read-only permissions",
    "table.no_filtered_results": "No filtered results",
    "button.praise": "",
    "label.prevent_welcome_email_assessor": "",
    "label.location_detail": "Location Detail",
    "label.optional": "(optional)",
    "errors.do_not_match": "Do not match",
    "label.use_comma_for_multiple_entries": "Use comma for multiple entries",
    "label.operating_authority": "Operating Partner",
    "label.activity_section": "Activity Section",
    "notifications.you_have_been_logged_out": "You have been logged out",
    "table.finished": "Finished",
    "button.same_as_billing": "Same as Billing",
    "table.payment": "Payment",
    "table.current_level": "Current Level",
    "button.view_nao": "Returned by Award Office (with a revision note)",
    "table.email_confirmation": "Email Confirmation",
    "moduleTitle.shipping_address": "Shipping Address",
    "label.secondary_phone_type": "Secondary Phone Type",
    "notifications.saved": "Saved",
    "pageTitle.all_participants": "All Participants",
    "label.first_name": "First Name",
    "label.oa_price": "OA Price",
    "table.award_mode": "Award mode",
    "tabs.api_keys": "",
    "award.award_detail": "Award Details",
    "tabs.user_management": "User Management",
    "tabs.all_events": "All Events",
    "notifications.history_record_has_been_removed": "History record has been removed",
    "award.no_data": "No data",
    "notifications.preparation_training_has_been_added": "Preparation and training has been added",
    "label.message": "Message",
    "notifications.participant_info_updated": "Participant information has been updated",
    "roles.nao_staff": "NAO Staff",
    "tabs.adventurous_journeys": "Adventurous Journeys",
    "label.gops": "",
    "route.upload": "Upload",
    "notifications.history_record_has_been_added": "History record has been added",
    "notifications.history_record_has_been_updated": "History record has been updated",
    "label.no_data": "No data",
    "button.add_coordinator": "Add Coordinator",
    "label.you_are_already_logged_as": "You are already logged as ",
    "route.my_national_office": "My National Office",
    "tabs.leaders": "Leaders",
    "label.email_confirmation": "Email Confirmation",
    "table.registration_date": "Registration Date",
    "notifications.role_has_been_removed": "Role has been removed",
    "button.move": "Move",
    "label.terms_and_conditions": "",
    "pageTitle.detail": "Details",
    "table.award_unit": "Award Unit",
    "sidebar.settings": "Settings",
    "dashboard.leader_state": "Leaders - by State",
    "notifications.award_unit_has_been_approved": "Award Unit has been approved",
    "states.awaiting_approval": "Awaiting Approval",
    "table.level": "Level",
    "table.action_requested": "Action Requested",
    "label.organisation_mode": "Organisation mode",
    "label.no_note": "No note",
    "tabs.my_events": "My Events",
    "notifications.participants_have_been_added": "Participants have been added",
    "tabs.registration_questions": "",
    "button.delete_registration": "Delete Registration",
    "notifications.parental_consent_link_has_been_sent": "Parental consent link has been sent",
    "moduleTitle.select_role_organization": "Select role & organisation",
    "label.experience": "Experience",
    "translationsManagement.modal.title": "",
    "table.ic": "Independent Country",
    "table.id": "ID",
    "label.notify_email_explanation": "The participant will be notified by email that their assessment request was not delivered to the Assessor. They will be asked to correct the Assessor's email address and ask for assessment again.",
    "participant.would_you_like_to_remove": "Would you like to delete this account?",
    "table.fields_included": "",
    "label.user_guide_web_leader": "User web guide - Award Leader",
    "label.journey_type": "Journey Type",
    "button.setup": "Setup",
    "tabs.my_national_office": "My National Office",
    "notifications.training_has_been_removed": "Training has been removed",
    "label.nominated_and_identified_persons": "Nominated and identified persons who can view all data but not edit",
    "moduleTitle.you_have_been_logged_out_due_to_inactivity": "You have been logged out due to inactivity",
    "states.award_leader_signoff": "Award Leader Authorisation",
    "table.award_signoff_attempts": "Award signoffs attempts",
    "sidebar.regions": "Regions",
    "label.activity_deleted_note": "This activity is deleted. You can restore it by clicking the button below.",
    "table.total": "Total",
    "errors.a_problem_has_occured_during_processing": "A problem has occurred during processing, see more information",
    "participant.participant_already_has_gold_award": "Participant already has a Gold award",
    "pageTitle.mro": "My Regional Office",
    "notifications.authorization_code_has_expired": "Authorisation code has expired",
    "moduleTitle.child_organization_labels": "",
    "aj.aj_events": "Adventurous Journey Events",
    "global.loading": "Loading",
    "label.gnipp": "GNIPP",
    "sidebar.registrations": "Registrations",
    "label.any_string": "Any string",
    "contact.change_contact_status": "Change Contact's Status",
    "tabs.registration": "Registration",
    "label.override_payment_note": "Override payment note",
    "notifications.section_has_been_signed_off": "Section has been signed off",
    "label.payment_date": "Payment Date",
    "button.approve": "Approve",
    "moduleTitle.loggin_in": "Logging in",
    "label.website": "Website",
    "label.role": "Role",
    "table.assessor_report": "Assessor report",
    "label.ue_fe": "",
    "label.please_comment_on_the_participants_effort": "",
    "label.previously_worked_as_assessor": "Previously worked as Assessor",
    "pageTitle.registrations": "Registrations",
    "parentalConsent.this_form_must_be_completed": "This form <strong>must</strong> be completed by a parent/guardian for participants under <strong> 18 years of age/the national age of legal responsibility in the country in which you live </strong> by a parent/guardian.",
    "button.apply": "",
    "errors.include_at_least_one_number": "Include at least one number character",
    "label.content_restore": "Refreshing session...",
    "logs.hour": "hour",
    "parentalConsent.i_have_read_and_understand": "7. I have read the welcome email that was sent to me. This contained the details I need to know relating to the participant's Award journey.",
    "notifications.award_was_deleted": "",
    "label.journey_category": "Journey Category",
    "notifications.search_cancelled": "Search was interrupted, you need to wait for the search to finish.",
    "route.detail": "Detail",
    "route.user_guide": "User guide",
    "moduleTitle.history": "History",
    "table.gop_name": "",
    "pageTitle.tasks_unassigned_participants": "Unassigned Participants",
    "states.inactive": "Archive",
    "pageTitle.search_results": "Search Results",
    "button.proceed_to_login": "Proceed to Login",
    "pageTitle.assessor_report_reject": "Assessor Report Revise",
    "notifications.contact_has_been_removed": "Contact has been removed",
    "sidebar.operating_authorities": "Operating Authorities",
    "label.no_note_from_participant": "No note from participant",
    "aj.preparation_and_training": "Preparation and training",
    "route.user_guide_web_leader": "User web guide - Award Leader",
    "label.position_in_organization": "Position in organisation",
    "errors.emails_dont_match": "Email does not match",
    "route.my_participants": "My Participants",
    "pageTitle.customisations": "Customisations",
    "tabs.localization_files": "Localisation Files",
    "table.assessor_approval": "Assessor approval",
    "tabs.related_contacts": "Related Contacts",
    "table.aus": "Award Units",
    "table.category": "",
    "errors.file_is_too_large": "",
    "label.possible_values": "Possible values:",
    "label.if_your_download_doesnt_start": "If your download doesn't start automatically please click here",
    "route.independent_award_centres": "Independent Award Centres",
    "pageTitle.user_guide": "User Guides",
    "button.visit": "",
    "label.hours_first_letter": "h",
    "pageTitle.my_organization_detail": "My Organisation - Detail",
    "pageTitle.nao_detail": "National Office - Details",
    "button.change": "Change",
    "award.aj": "Adventurous Journey",
    "table.award_state": "Award State",
    "pageTitle.tasks_award_signoff": "Award Authorisation",
    "pageTitle.regions": "Regions",
    "notifications.award_has_been_signed_off": "Award has been signed off",
    "dashboard.award_approved_by": "Awards approved - by level in 2016",
    "tabs.new_template": "New Template",
    "error.parent_email_must_be_filled": "",
    "label.organisation_invoicing_name": "Organisation Invoicing Name",
    "pageTitle.related_contacts": "Related Contacts",
    "button.try_again": "Close warning and try again",
    "label.cannot_be_change_to_another": "Cannot be changed to another award level",
    "notifications.lead_coordinator_has_been_set": "New Lead Coordinator has been set",
    "label.training_name": "Training Name",
    "moduleTitle.new_contact": "New Contact",
    "translationsManagement.modal.updateTitle": "",
    "moduleTitle.offline_award_units_signoff": "Offline Award Leader signoff",
    "notifications.award_level_has_been_changed": "Award level has been changed",
    "label.subject": "Subject",
    "route.silver_level": "Silver Level",
    "label.privacy_notice": "",
    "label.switch_organization": "Switch Organisation",
    "meta.dofe_name": "The Duke of Edinburgh’s International Award",
    "route.profile": "Profile",
    "roles.super_user": "Super-user",
    "dashboard.while_you_were_gone": "While you were gone",
    "label.no_note_from_award_leader": "Returned by Award Office (without a revision note)",
    "label.middle_name": "Middle Name",
    "moduleTitle.new_activity": "New Activity",
    "organisation.would_you_like_to_remove": "Would you like to remove this organisation?",
    "label.state_province": "State/Province/Region",
    "moduleTitle.your_home_address": "Your home address",
    "tabs.sign_offs": "Authorisations",
    "moduleTitle.logs": "Logs",
    "button.view_more": "View more",
    "label.profile": "Profile",
    "label.title": "Title",
    "tabs.award_signoff": "Award Authorisation",
    "label.post_code": "Post Code",
    "states.ceremony_certificate": "Ceremony",
    "label.code": "Operator Reference",
    "parentalConsent.i_consent_to_the_provision_of_any": "13. I consent to the personal information contained within this registration being available to the Award Unit, Leader and National Office and relevant people at the International Award Foundation.  This information will be treated within the context of the Privacy Act 2020 and the boundaries stated within it.",
    "label.user_guide_web_participant": "User web guide - Participant",
    "label.award_unit_type": "Award Unit Type",
    "states.complete": "",
    "table.participant_state": "Participant State",
    "pageTitle.my_organization_payment": "My Organisation - Payment",
    "table.approved": "Approved",
    "pageTitle.my_organization_contacts": "My Organisation - Contacts",
    "warning.award_marked_as_paid_registration": "",
    "states.change_to_state": "Change to <strong>{state}</strong>",
    "label.integer": "Integer",
    "notifications.translationUpdateInterrupted": "",
    "notifications.password_has_been_changed": "Password has been changed",
    "button.invite_assessor": "Invite Assessor",
    "label.other_activity": "Other Activity",
    "notifications.parental_consent_has_been_sent": "Parental consent has been sent",
    "button.revise": "Revise",
    "errors.end_date_must_be_after_start_date": "End date must be after start date",
    "label.award_leader_signoff_date": "Award Leader Authorisation date",
    "parentalConsent.i_understand_every_participant_must": "8. I understand each participant participates in the  Award through an Award Unit.  The Unit has the discretion to accept or decline participants or the activity they propose to complete their Award.",
    "moduleTitle.policies": "",
    "pageTitle.tasks_aj": "Adventurous Journey",
    "global.day": "day",
    "moduleTitle.coordinator": "Coordinator",
    "label.region": "Region",
    "button.add_history_record": "Add history record",
    "moduleTitle.adventurous_journey_template_settings": "Adventurous Journey Template Settings",
    "notifications.personal_details_have_been_updated": "Personal details have been updated",
    "sidebar.ics": "Independent Countries",
    "table.independent_award_centre": "Independent Award Centre",
    "label.undelivered_mail_reason": "Reason for non-delivery of email",
    "table.utc_date_time": "",
    "moduleTitle.emails": "",
    "label.backoffice": "",
    "moduleTitle.parent_consent": "Parent / Guardian Consent",
    "label.photo_consent_given": "Participant agrees that we can use his/her profile picture for promotion",
    "moduleTitle.authorising_contact": "Authorising Contact",
    "label.assessment_with_role": "{role} assessment",
    "dashboard.type_of_awards": "Type of Award Unit",
    "moduleTitle.payment": "Payment",
    "states.in_progress": "In Progress",
    "logs.no_logs": "No logs",
    "sidebar.my_office": "My Office",
    "label.assessor_report": "Assessor Report",
    "notifications.rp_has_been_signed_off": "Gold Residential Project has been signed off",
    "tabs.labels": "",
    "sidebar.payments": "Payments",
    "meta.profile_questions": "Profile Questions",
    "label.fax": "Fax",
    "label.email_help_custom_link": "",
    "label.last_name": "Last Name",
    "organisation.manage_gop": "",
    "table.parental_consent": "",
    "dashboard.participant_by_level": "Participants - by Level",
    "tabs.award_leaders": "Award Leaders",
    "label.i_confirm_that_ive_witnessed": "I confirm that I've witnessed the Participants log book for the activities below",
    "table.lead_coordinator": "",
    "states.deleted": "Deleted",
    "label.no_answers": "No answers",
    "button.add": "Add",
    "label.exchequer_number": "Exchequer A/c No.",
    "label.waiting": "Waiting",
    "label.email_help_person_full_name": "",
    "tasks.return_registration": "Revise Registration",
    "notifications.state_aj_preparation_training_has_been_changed": "State of Adventurous Journey Preparation & Training has been changed.\n",
    "label.parent_approval": "Parent Approval",
    "table.assessor_approve": "Assessor approve",
    "errors.some_fields_requires_your_attention": "Some fields require your attention",
    "aj.qualifying_journey": "Qualifying Journey",
    "route.awards": "Awards",
    "table.registration": "Registration",
    "pageTitle.assessors": "Assessors",
    "notifications.award_has_been_updated": "Award has been updated",
    "errors.must_be_one_of": "Must be one of: {enums}",
    "pageTitle.logs": "Logs",
    "notifications.notifications.invitation_has_been_sent": "Invitation has been sent",
    "route.national_offices": "National Offices",
    "notifications.training_has_been_updated": "Training has been updated",
    "label.parent_last_name": "Last name of Parent / Guardian",
    "table.leaders": "Leaders",
    "states.award_level_complete": "Award Level Complete",
    "button.reset": "Reset",
    "sidebar.my_award_unit": "My Award Unit",
    "pageTitle.all_aj_events": "All Adventurous Journey Events",
    "label.activity": "Activity",
    "moduleTitle.are_you_sure": "Are you sure?",
    "route.gold_level": "Gold Level",
    "table.evidence": "Evidence",
    "label.delivery_confirmed": "Delivery Confirmed",
    "parentalConsent.as_the_parent": "As the parent/guardian, I give consent for any images to be used by the Foundation for promotional purposes.",
    "label.awardMode.offline": "Offline",
    "tasks.approve_registration": "Approve Registration",
    "note.change_the_email_will_change": "Note: Changing the Email will change also the Migrated Contact email",
    "notifications.participant_has_been_approved": "Participant has been approved",
    "label.reached_activity_limit": "Activities limit reached in this activity section. Participant can have maximum of 3 activities in each section.",
    "label.facebook": "Facebook",
    "notifications.label_has_been_removed": "",
    "label.action_required": "",
    "notifications.preparation_training_has_been_removed": "Preparation and training has been removed",
    "pageTitle.settings": "Settings",
    "participant.level_registration_date": "{value} Registration Date",
    "notifications.question_has_been_removed": "Question has been removed",
    "label.email_help_award_leader_full_name": "",
    "sidebar.leaders": "Leaders",
    "notifications.participants_have_been_transferred": "Participants have been transferred",
    "tabs.assessors": "Assessors",
    "sidebar.dashboard": "Dashboard",
    "pageTitle.independent_award_centers": "Independent Award Centres",
    "label.search": "Search",
    "moduleTitle.office_labels": "",
    "label.note_from_participant": "Note from participant",
    "errors.required_field": "Required field",
    "tasks.approve_task": "Approve Task",
    "logs.edit_log": "Edit Log",
    "table.state": "State",
    "moduleTitle.level_summary": "",
    "moduleTitle.guides": "",
    "modal.close": "Close",
    "label.parent_first_name": "First name of Parent / Guardian",
    "parentalConsent.i_understand_that_the_participant": "1.  I understand I am receiving this form because this participant has listed you to provide this consent. I understand this registration cannot proceed until this form (parental/guardian consent) is completed and submitted to the Award Unit, provision has been made for payment of the registration fee and it has been accepted by the Award Leader.",
    "tabs.award_units": "Award Units",
    "table.hours": "Hours",
    "label.type": "Type",
    "notifications.adventurous_journey_has_been_removed": "Adventurous journey has been removed",
    "label.aj_is_not_approved_yet": "Adventurous Journey is not approved yet",
    "roles.authorizing_contact": "Authorizing Contact",
    "table.date_submitted_to_office_signoff": "Date Submitted by participant / returned by Award Office",
    "notifications.section_has_been_returned": "Section has been revised",
    "table.created_by": "Created by",
    "route.user_guide_web_participant": "User web guide - Participant",
    "route.templates": "Templates",
    "states.awaiting_sign_off": "Award Leader Authorisation",
    "table.phone": "Phone",
    "label.parental_consent": "Parental Consent",
    "label.org_contact_will_be_deleted": "",
    "route.bronze_level": "Bronze Level",
    "label.invoice_currency": "Invoice Currency",
    "button.new_label": "",
    "error.server_cannot_be_reached_at_the_moment": "Server cannot be reached at the moment. Please try again later. If the problem persists, please contact our support team.",
    "notifications.contact_has_been_created": "Contact has been created",
    "pageTitle.profile_questions": "Profile Questions",
    "table.observation_files": "Observation files",
    "table.participants": "Participants",
    "tasks.no_evidence": "No evidence provided",
    "button.edit": "Edit",
    "moduleTitle.leader": "Leader",
    "notifications.new_template_has_been_updated": "New template has been updated",
    "table.name": "Name",
    "label.no_results": "No results",
    "moduleTitle.documents": "Documents",
    "button.invite": "Invite",
    "label.goal": "Goal",
    "pageTitle.nao_award_units": "National Office - Award Units",
    "label.award_delete_participant_id": "",
    "errors.at_least_num_characters": "At least {length} characters long",
    "label.email_help_note": "",
    "label.person_status.activating": "",
    "moduleTitle.remove_role": "Remove role?",
    "label.total": "Total",
    "label.delete_participant_award_info": "",
    "route.leaders": "Leaders",
    "table.start_date": "Start Date",
    "moduleTitle.coordinators": "Coordinators",
    "button.create": "Create",
    "tabs.awards": "Awards",
    "parentalConsent.form_has_been_sent": "Parental consent has been sent.",
    "states.journey_approval": "Journey Approval",
    "pageTitle.reports": "Reports",
    "table.journey_type": "Journey Type",
    "label.yes": "Yes",
    "pageTitle.assessor_report": "Assessor Report",
    "label.organization": "Organisation",
    "notifications.award_leader_has_been_updated": "Award Leader has been updated",
    "moduleTitle.edit_role": "Edit Role",
    "table.journey_activity": "Journey Activity",
    "label.location": "Location",
    "label.update_translations_error_item": "",
    "pageTitle.adventurous_journeys": "Adventurous Journeys",
    "global.assessor": "Assessor",
    "moduleTitle.profile_questions": "Profile Questions",
    "activity.cannot_edit_activity_if_award_in_state": "Cannot edit activity if award is in {state} state",
    "moduleTitle.assessor_detail": "Assessor Details",
    "parentalConsent.i_understand_that_upon_acceptance_into": "10. I understand once this registration is approved the participant will complete the Award through the Online Record Book including recording all their activity logs and all other requirements in order to complete the Award level.",
    "notifications.award_has_been_returned": "Award has been revised",
    "label.code_of_conduct": "",
    "button.new_contact": "New Contact",
    "tabs.payments": "Payments",
    "roles.naa_oa_staff": "NAA OA Staff",
    "label.switch_organisation_hint": "You can open this dialog anytime by choosing 'Switch Organisation' in the upper-right corner menu",
    "label.expiration_date": "Expiration Date",
    "tabs.participants": "Participants",
    "table.practice": "Practice",
    "notifications.one_activity_has_to_remain": "One activity in section has to remain active",
    "label.qualifications": "Qualifications",
    "states.organization_approval": "Award Office Authorisation",
    "errors.must_be_an_integer": "Must be an integer",
    "participant.send_confirmation_email_again_question": "Send confirmation email again?",
    "button.dismiss": "Dismiss",
    "table.advice": "Advice",
    "label.years_of_working_experience": "Years of working experience",
    "notifications.search_failed": "There was an error while searching. Please try again later.",
    "notifications.changes_have_been_saved": "",
    "moduleTitle.resend_parental_consent_link": "Resend parental consent link?",
    "label.activity_type": "Activity Type",
    "label.change_award": "Change Award Level",
    "label.email": "Email",
    "button.remove": "Remove",
    "button.download": "Download",
    "label.vat_treatment": "VAT Treatment",
    "pageTitle.aj_template_new": "New Adventurous Journey Template",
    "table.per_page": "per page",
    "notifications.translations_has_been_updated": "",
    "notification.award_mode_has_been_updated": "Award's mode has been updated",
    "tasks.revise_item": "Revise Item",
    "button.resend_parental_consent": "Resend parental consent",
    "table.weeks_completed_required": "Weeks Completed / Required",
    "label.last_modified": "Last modified",
    "table.major": "Major",
    "label.vat_number": "VAT No.",
    "errors.passwords_dont_match": "Passwords do not match",
    "table.country": "Country / Territory",
    "sidebar.guides_and_policies": "",
    "notifications.question_has_been_updated": "Question has been updated",
    "table.participant_name": "Participant Name",
    "label.registration_approval_date": "",
    "notifications.auth_code_is_no_longer_valid": "Authorization code is no longer valid",
    "errors.must_be_no_more_than": "Must be no more than {max} characters",
    "notifications.event_has_been_rejected": "Event has been revised",
    "tabs.customizations": "Customisations",
    "label.name_organization": "Name",
    "button.add_log": "Add Log",
    "moduleTitle.invite_assessor": "Invite Assessor",
    "label.resend_confirmation_email": "",
    "text.all_participants_will_be_transfered": "All participants will be transfered to a new Award Leader",
    "label.repeat_email": "Repeat Email",
    "errors.email_or_phone_required": "Email or phone is required",
    "notifications.role_has_been_updated": "Role has been updated",
    "roles.if_staff_stat_user": "IF Statistical User",
    "participant.delete_account": "Delete Account",
    "moduleTitle.would_you_like_to_remove_this_log": "Would you like to delete this log?",
    "sidebar.sgops": "",
    "label.prepare_new_email": "",
    "table.journey_category": "Journey Category",
    "sidebar.manual_data_import": "Manual data import",
    "label.created_after_date": "",
    "route.my_organization": "My Organisation",
    "button.show_list": "",
    "label.leaders": "Leaders",
    "notifications.log_has_been_modified": "Log has been modified",
    "button.upload_file": "Upload File",
    "moduleTitle.which_section_do_you_want_to": "Which section do you want to return to 'In Progress'?",
    "tabs.bronze_level": "Bronze Level",
    "notifications.participants_have_been_saved": "Participants have been saved",
    "pageTitle.aj_template_detail": "Adventurous Journey",
    "label.parent_email": "Parent&#39;s / Guardian&#39;s Email",
    "map.appr_location": "Approximate address:",
    "notifications.log_has_been_removed": "Log has been removed",
    "notifications.label_has_been_assigned": "",
    "pageTitle.tasks_undelivered_emails": "Undelivered Emails",
    "button.stay": "Stay",
    "table.previous_level": "Previous Level",
    "label.award_start_date": "Award Start Date",
    "assessor_report.returned_to_participant": "Returned to Participant",
    "pageTitle.tasks_assessors_registration": "Assessor Registration",
    "aj.cannot_modify_award": "The Award Level cannot be modified if participants are assigned to the Adventurous Journey",
    "moduleTitle.lost_internet_connection": "It looks like you lost internet connection",
    "states.ceremony": "Ceremony",
    "participant.reactivate_account": "Reactivate account",
    "label.birthdate": "Date of Birth",
    "pageTitle.assessment_send_successfully": "Assessment sent successfully",
    "states.assessor_approval": "Assessor Approval",
    "award.change_award_level": "Change Award Level",
    "label.url_no_longer_valid": "This URL is no longer valid.",
    "button.update": "Update",
    "label.secondary_email": "Secondary Email",
    "button.role_edit": "Edit",
    "table.award_leader": "Award Leader",
    "label.level": "Level",
    "tasks.evidence": "Evidence",
    "notifications.participant_is_already_in_list": "Participant is already in the list",
    "button.clear": "Clear",
    "label.allow_log_after_25_yoa": "",
    "states.setup": "Setup",
    "table.activity": "Activity",
    "label.copy_to_clipboard": "{text} was copied to the clipboard.",
    "route.award_units": "Award Units",
    "button.upload_photo": "Upload Picture",
    "table.hours_completed_required": "Completed / Required",
    "table.first_name": "First Name",
    "notifications.adventurous_journey_has_been_returned": "Adventurous Journey has been revised",
    "pageTitle.national_offices": "National Offices",
    "notifications.you_have_been_logged_in": "You have been logged in",
    "logs.offline": "",
    "moduleTitle.add_role": "Add role",
    "label.user_app_guide_participant": "User app guide - Participant",
    "notifications.file_has_been_removed": "File has been removed",
    "label.send_message": "",
    "button.select": "Select",
    "label.reason_of_deletion": "Reason of deletion",
    "label.user_guide": "User guide",
    "pageTitle.nao_participants": "National Office - Participants",
    "tabs.sub_operating_partners": "",
    "table.uploaded_by": "Uploaded by",
    "tasks.approve_item": "Approve Item",
    "tasks.restore_participant_registration": "Restore participant registration?",
    "label.awardMode.hybrid": "Hybrid",
    "table.first_activity_started": "First activity started",
    "moduleTitle.dates": "Dates",
    "table.no_results": "No results",
    "states.registration_approval": "Registration Approval",
    "table.breakdown_of_hours": "Breakdown of hours",
    "pageTitle.tasks_registration": "Participant Registration",
    "button.create_new": "Create New",
    "sidebar.todolist": "To Do List",
    "label.active_participants": "Active Participants",
    "moduleTitle.postalAddress": "",
    "tasks.return_task": "Revise Task",
    "organisation.change_organisation_state": "Change Organisation's State",
    "moduleTitle.roles": "Roles",
    "label.no_config_key_available": "No configuration keys available for this section",
    "placeholder.selectLanguage": "",
    "states.office_signoff": "Award Office Authorisation",
    "notifications.translations_has_been_updated.failure": "",
    "logs.minute": "minute",
    "label.last_activity": "Last Activity",
    "sidebar.user_guide": "User Guides",
    "label.trained_award_leader": "a trained Award Leader",
    "table.progress": "Progress",
    "table.suboperating_authorities": "Sub-Operating Authorities",
    "activity.cannot_edit_activity_offline": "This Participant is operating in Offline mode.<br><br>\nYou cannot edit; Activity, Adventurous Journey or Gold Residential Project if the Award is in semi-offline mode.",
    "label.user_does_not_have_permissions": "User <strong>{user}</strong> doesn't have permissions to see this content.",
    "notifications.assessor_has_been_approved": "Assessor has been approved",
    "route.activity_approval": "Activity Approval",
    "moduleTitle.role": "Role",
    "button.run": "Run",
    "label.to": "To",
    "notifications.file_has_been_updated": "File has been updated",
    "moduleTitle.edit_coordinator": "Edit coordinator",
    "notifications.authorization_code_is_no_longer_valid": "Authorization code is no longer valid",
    "button.reject": "Revise",
    "label.label.participant_status": "Participant Status",
    "award.gold_level": "Gold Level",
    "sidebar.variables": "Variables",
    "parentalConsent.checkbox_copy": "I confirm that I am the parent/guardian of {firstName} {lastName}. I give my consent for him/her to participate in the Award in {organisationName} under supervision of a trained Award Leader. I have read, understood and agree with the requirements and conditions of participation in the Award, as described above and on the website of the Award Operator.",
    "button.go_to_dashboard": "Go to dashboard",
    "button.add_option": "Add option",
    "label.is_completed": "Completed",
    "pageTitle.award_units": "Award Units",
    "states.completed": "Completed",
    "button.adventurous_journey_template_settings": "Adventurous Journey Template Settings",
    "label.system_rights": "System Rights",
    "label.assessor_assesstment_award_start_date": "",
    "label.update_translation_question": "",
    "button.login": "Login",
    "label.name_of_the_unit": "Name of the unit",
    "button.send": "Send",
    "award.ajs": "Adventurous Journeys",
    "meta.payments_expired": "Payments - Expired",
    "label.age": "Age",
    "notifications.payment_info_updated": "Payment information has been updated",
    "table.is_completed": "Completed",
    "table.invited_by": "Invited by",
    "route.files": "Files",
    "route.assessors": "Assessors",
    "info.aj_supervisor_is_mandatory": "",
    "pageTitle.my_participants": "My Participants",
    "label.change_leader_status": "Change Leader's Status",
    "moduleTitle.parent_consent_form": "Parent / Guardian Consent Form",
    "notifications.authorization_contact_has_been_set": "Authorisation contact has been set",
    "button.close": "Close",
    "label.independent_country": "Independent Country",
    "notifications.aj_preparation_training_has_been_returned": "Adventurous Journey Preparation & training has been revised",
    "route.history_log": "History Log",
    "participant.account_settings": "Account Settings",
    "label.bulk_action_error_item": "",
    "label.orb_account": "ORB Account",
    "notifications.file_url_is_not_specified_in_configuration": "File URL is not specified in configuration",
    "notifications.award_unit_has_been_removed": "Award Unit/IAC has been removed",
    "table.parent": "Parent",
    "label.mode_of_transport": "Mode of Transport",
    "label.parental_consent_email_info": "",
    "label.current_award": "Current Award",
    "table.action": "Action",
    "pageTitle.suboperating_authorities": "Sub-Operating Authorities",
    "notifications.award_leader_has_been_assigned": "Award leader has been assigned",
    "tabs.sign_offs_locally": "Local Authorisation",
    "Activity log has been restored": "notification.log_has_been_restored",
    "sidebar.naos": "NAOs",
    "tabs.aj_templates": "Adventurous Journey Templates",
    "notifications.logging_out": "Logging out...",
    "label.update_label": "",
    "button.organisation_settings": "Organisation Settings",
    "tabs.independent_award_centers": "Independent Award Centres",
    "label.current": "Current",
    "table.location": "Location",
    "button.search": "Search",
    "notifications.aj_preparation_training_has_been_approved": "Adventurous Journey Preparation & training has been approved",
    "route.participants": "Participants",
    "label.other_location_information": "Other Location Information",
    "label.number_of_records": "Number of records",
    "translationsManagement.infoLabel": "",
    "parentalConsent.i_consent_to_pay_all": "5. I understand costs associated with accidents or injury are managed under the Award Unit’s Safety Management Plan  and through ACC.",
    "label.nationality": "Nationality",
    "states.approval": "Approval",
    "notifications.something_went_wrong": "Something went wrong",
    "aj.practice": "Practice",
    "label.addressLine2": "Address Second Line",
    "label.please_leave_a_note": "Please leave a note",
    "placeholder.select": "Select",
    "label.observations": "Observations",
    "label.aim": "Aim",
    "label.addressLine1": "Address First Line",
    "roles.aj_instructor": "AJ Instructor",
    "meta.payments_waiting": "Payments - Waiting",
    "label.award_to_delete": "",
    "label.category": "",
    "roles.instructor": "Instructor",
    "moduleTitle.remove_customization_and_reset": "Remove customization and reset config value?",
    "notifications.participant_registration_has_been_restored": "Participant registration has been restored",
    "organisation.change_award_unit_mode": "Change Organisation's Mode",
    "table.organization_type": "",
    "notifications.participant_has_been_deleted": "Participant has been deleted",
    "label.language_settings": "Language Settings",
    "notifications.event_has_been_approved": "Event has been approved",
    "label.password": "Password",
    "label.text": "Text",
    "table.observations": "Observations",
    "notifications.participant_has_been_created": "Participant has been created",
    "table.note_for_al": "Note for Award Leader",
    "label.payment_confirmed": "Payment Confirmed",
    "label.previous_completed_award_level": "Previous Level (not ORB)",
    "pageTitle.new_aj_event": "New Adventurous Journey Event",
    "label.backend": "",
    "label.relationship_to_participant": "Relationship to participant",
    "award.physical_recreation": "Physical Recreation",
    "contact.collect_emails": "",
    "moduleTitle.assessor_report_reject": "Assessor Report Reject",
    "label.supervisor_report": "Supervisor Report",
    "table.role": "Role",
    "route.user_guide_web_nao": "User web guide - NAO",
    "label.page_not_found": "404 - Page not found.",
    "table.labels": "",
    "notifications.file_has_been_uploaded": "File has been uploaded",
    "moduleTitle.address": "Address",
    "moduleTitle.lead_coordinator": "Lead coordinator",
    "pageTitle.login": "Login",
    "label.frontoffice": "",
    "participant.would_you_like_to_remove_registration": "",
    "notifications.rp_has_been_setup": "Gold Residential Project has been set up",
    "moduleTitle.award_unit": "Award Unit",
    "button.remove_file": "Remove file",
    "moduleTitle.billing_address": "Billing Address",
    "pageTitle.my_aj_events": "My Adventurous Journey Events",
    "route.tasks": "Tasks",
    "button.confirm": "Confirm",
    "label.national_award_authority": "National Award Authority",
    "label.independent_award_centre": "Independent Award Centre",
    "award.generate_award_report": "Generate Report",
    "route.my_region_office_customization": "My Regional Office - Customisations",
    "label.email_help_aj_category": "",
    "label.your_report_has_been_rejected": "",
    "notifications.password_change_request_has_been_sent": "Password change request has been sent",
    "tabs.detail": "Detail",
    "participant.change_participant_status": "Change Participant's Status",
    "table.key": "",
    "label.find_address": "Find Address",
    "notifications.assessor_has_been_rejected": "Assessor has been revised",
    "label.transfer_participants": "Transfer Participants",
    "button.continue_to_payment_gateway": "Continue to payment gateway",
    "notifications.participant_registration_has_been_removed": "Participant registration has been removed",
    "moduleTitle.page_not_found": "404 - Page not found",
    "route.adventurous_journeys": "Adventurous Journeys",
    "states.registration_assessment": "Registration Assessment",
    "heading.change_award_unit_mode": "Change Award Unit's mode",
    "label.user_guide_web_nao": "User web guide - NAO",
    "tabs.silver_level": "Silver Level",
    "table.paid_by": "Paid by",
    "label.your_report_has_been_successfully_sent": "Your report has been successfully sent.",
    "sidebar.my_organization": "My Organisation",
    "pageTitle.participants": "Participants",
    "notifications.preparation_training_has_been_updated": "Preparation and training has been updated",
    "moduleTitle.server_is_unreachable": "Server is unreachable",
    "label.last_activity_date": "",
    "award.bronze_level": "Bronze Level",
    "moduleTitle.award_units": "Award Units",
    "table.completed": "Completed",
    "moduleTitle.revise_message": "Revise message",
    "table.lastUsed": "",
    "award.bronze_to_gold_level": "",
    "button.change_password": "Change password",
    "label.nao_price": "NAO Price",
    "label.payment_state": "Payment State",
    "label.wwc_expired": "WWC expired",
    "label.award_office_signoff_date": "Award Office Authorisation date",
    "label.award_unit": "Award Unit",
    "award.gold_level_short": "Gold",
    "moduleTitle.other_info": "Other Information",
    "table.note": "Note",
    "label.search_by_email_first_or_last": "Search by email, first or last name",
    "tabs.history": "History",
    "notifications.label_has_been_created": "",
    "tabs.unassigned_participants": "Unassigned Participants",
    "table.main_award_leader": "Coordinator",
    "parentalConsent.i_as_the_parent": "3. I understand that some activities contain elements of risk.",
    "label.state": "State",
    "notifications.award_leader_has_been_removed": "Award Leader has been removed",
    "tabs.organization_detail": "Organisation Details",
    "table.operating_authorities": "Operating Authorities",
    "label.available_labels": "",
    "modal.select": "Select",
    "tabs.expired_payments": "Expired Payments",
    "moduleTitle.note_for_al": "Note for Award leader",
    "moduleTitle.confirm": "Confirm",
    "notification.new_activity_added": "New activity has been added",
    "notifications.award_leader_has_been_moved": "Award leader has been moved",
    "label.award_mode": "Award Mode",
    "label.phone": "Phone",
    "notifications.organization_has_been_updated": "Organisation has been updated",
    "moduleTitle.assessor": "Assessor",
    "label.bulk_action_confirmation": "",
    "table.parent_approval": "Parent Approval",
    "label.date_of_delivery": "Date Received",
    "sidebar.assessors": "Assessors",
    "label.journey_activity": "Journey Activity",
    "award.inactive_award": "Inactivate Award",
    "label.end_date": "End Date",
    "label.orb_testing": "ORB Testing",
    "label.no_activities": "No activities",
    "moduleTitle.please_confirm": "Please confirm",
    "button.login_with_another_account": "Login with different account",
    "tasks.reject_registration": "Revise Registration",
    "label.submitted_after_date": "Submitted after",
    "label.update_translations_successful": "",
    "button.assign_leader": "Assign Leader",
    "table.already_running": "Already running",
    "label.no": "No",
    "label.count_items_selected": "",
    "label.secondary_phone_number": "Secondary Phone Number",
    "label.my_experience": "My Experience",
    "notifications.adventurous_journey_has_been_approved": "Adventurous Journey has been approved",
    "pageTitle.mro_detail": "My Regional Office - Details",
    "moduleTitle.nao_specific_info": "NAO Specific Information",
    "label.preparing_document_for_import": "Preparing document for import",
    "tasks.observations": "Observations",
    "notifications.confirmation_email_has_been_sent": "Confirmation email has been sent",
    "button.restore": "Restore",
    "label.importing_file": "Importing file",
    "label.or_dont_agree": "Or don't agree? You can",
    "moduleTitle.award_leader": "Award Leader",
    "label.me": "(me)",
    "tabs.sub_global_operating_partners": "",
    "button.export_table": "Export Table",
    "organisation.move_award_unit": "Move Award Unit",
    "label.file_category": "",
    "notifications.connecting_to_server": "Connecting to server...",
    "parentalConsent.i_understand_that_a_and_b": "11. I understand that: <br /> a. The participant must only undertake activities that are covered by the Award Unit’s Safety Management Plan provisions and other relevant policies; and <br /> b. Any adults assisting with Award activity shall also follow the provisions within the Award Unit’s Safety Management Plan.",
    "table.reason": "Reason",
    "pageTitle.contacts": "Contacts",
    "states.award_leader_approval": "Award Leader Authorisation",
    "meta.payments": "Payments",
    "label.suboperating_authority": "Sub-Operating Partner",
    "route.my_region_office": "My Regional Office",
    "states.registration_not_approved": "Registration not approved",
    "label.direct_entrant": "Direct entrant",
    "tabs.all_participants": "All Participants",
    "tabs.payment": "Payment",
    "label.email_help_activity_name": "",
    "title.update_report": "",
    "label.repeat_new_password": "Repeat New Password",
    "label.other_roles": "ORB profile page",
    "logs.hours": "hours",
    "notifications.spreadsheet_has_been_imported_successfully": "Spreadsheet has been imported successfully",
    "label.bulk_action_question": "",
    "moduleTitle.personal_details": "Personal Details",
    "label.bulk_action_emailing": "",
    "route.my_events": "My Events",
    "button.delete_award": "",
    "errors.include_both_lower_and_upper_case": "Include both lower and upper case characters",
    "tabs.removed_participant_registrations": "Removed Participant Registrations",
    "sidebar.mynao": "My NAO",
    "tabs.office_details": "Office Details",
    "label.major": "Major",
    "tabs.documents": "Documents",
    "label.new_password": "New Password",
    "sidebar.adventure_journey": "Adventurous Journey",
    "pageTitle.customizations": "Customisations",
    "moduleTitle.assessor_report": "{role} report",
    "label.registration_date": "Registration Date",
    "notifications.training_has_been_added": "Training has been added",
    "aj.qualifying": "Qualifying",
    "moduleTitle.you_have_been_logged_out_session_terminated": "You have been logged out because the session has already been terminated",
    "award.service": "Voluntary Service",
    "notifications.rp_state_has_been_changed": "Gold Residential Project state has been changed",
    "label.ctest_access": "Test site access",
    "table.created": "Created",
    "tasks.revise_task": "Revise Task",
    "button.assign": "Assign",
    "button.return": "Revise",
    "table.status": "Status",
    "button.restore_activity": "Restore Activity",
    "tabs.new_aj_event": "New Adventurous Journey Event",
    "roles.if_staff_viewer": "IF Staff Viewer",
    "notifications.new_template_has_been_created": "New template has been created",
    "global.something_went_wrong": "Something went wrong",
    "table.expire_day": "Expire day",
    "tabs.history_log": "History Log",
    "label.form_of_payment": "Form of Payment",
    "button.add_training": "Add training",
    "label.par_reg_cust_note": "",
    "label.my_qualification": "My Qualification",
    "button.add_new_profile_question": "Add new profile question",
    "table.operating_authority": "Operating Partner",
    "table.aim": "Aim",
    "table.awards": "Awards",
    "participant.deactivate_account": "Deactivate account",
    "table.organization_name": "",
    "label.email_help_award_leader_first_name": "",
    "table.date": "Date",
    "tasks.would_you_like_to_delete": "Would you like to delete this participant?",
    "notifications.configuration_value_has_been_updated": "Configuration value has been updated",
    "ajTemplates.fill_from_template": "Fill from template",
    "contact.send_test_email": "Send Test Email",
    "moduleTitle.aj_preparation_and_training": "Adventurous Journey preparation & training",
    "label.ce_be": "",
    "button.notify_participant": "Return to Participant",
    "label.parent_phone": "Parent&#39;s / Guardian&#39;s Phone Number",
    "label.nao_regulations": "",
    "award.skills": "Skills",
    "label.reject_application": "Return this sign-off request to the participant.",
    "leader.delete_account": "Delete Account",
    "table.assign": "Assign",
    "roles.aj_supervisor": "Adventurous Journey Supervisor",
    "label.logout": "Logout",
    "moduleTitle.award_leader_edit": "Edit Award Leader",
    "moduleTitle.training": "Training",
    "notifications.coordinator_has_been_removed": "Coordinator has been removed",
    "tabs.operating_partners": "",
    "moduleTitle.main_award_leader": "Coordinator",
    "label.bulk_action_successful": "",
    "tasks.clear_email_revision": "Clear email revision",
    "table.preparation": "Preparation",
    "table.delete": "Delete",
    "label.safeguarding_policy": "",
    "sidebar.reports": "Reports",
    "pageTitle.sub_global_operating_partners": "",
    "label.is_major_activity_confirmation": "The participant already has a major activity on different award level. Do you want to add another one?",
    "pageTitle.operating_authorities": "Operating Authorities",
    "label.delete_participant_award_modal_question_detail": "",
    "label.confirmed": "Confirmed",
    "notifications.invitation_has_been_sent": "Invitation has been sent",
    "pageTitle.independent_countries": "Independent Countries",
    "label.assessors_email": "Assessor's Email",
    "tasks.approve_assessor_registration": "Approve Assessor Registration",
    "table.award_duration": "Award Duration",
    "notifications.organization_has_been_moved": "Organisation has been moved",
    "pageTitle.nao_payment": "National Office - Payment",
    "participant.history_log": "History Log",
    "label.rejected_with_note": "",
    "label.already_running": "Already running",
    "button.continue": "",
    "award.no_data_to_show": "No data to show",
    "participant.send_email_invitation_again_question": "Send email invitation again?",
    "label.reason_for_changing_assessor": "Reason for changing the assessor",
    "button.delete": "Delete",
    "moduleTitle.requirements_and_conditions": "Requirements and Conditions",
    "roles.leader": "Leader",
    "label.if_download_doesnt": "",
    "dashboard.your_todo_list": "Your To Do List",
    "notifications.award_unit_has_been_returned": "Award unit has been revised",
    "moduleTitle.participant_activities": "Participant's activities",
    "errors.qualification_or_experience_required": "",
    "label.active_leaders": "Active Leaders",
    "aj.preparation": "Preparation",
    "button.change_state": "Change State",
    "label.current_password": "Current Password",
    "pageTitle.global_operating_partners": "",
    "moduleTitle.contact_settings": "Contact Settings",
    "button.remove_photo": "Remove Photo",
    "notifications.activity_has_been_setup": "Activity has been set up",
    "errors.must_be_more_than": "Must be more than {limit}",
    "table.goal": "Goal",
    "notifications.coordinator_has_been_set": "Coordinator has been set",
    "label.cc": "Cc",
    "label.duration": "Duration",
    "table.actions": "Actions",
    "participant.send_email_invitation_again": "Send email invitation again?",
    "moduleTitle.would_you_like_to_remove_participant": "Would you like to delete this participant registration?",
    "parentalConsent.i_authorise_employees": "4. I authorise employees, officers or agents of the Award Unit to offer aid as necessary to the participant.",
    "button.reload_page": "Reload Page",
    "moduleTitle.update_translations": "",
    "label.report_description": "",
    "table.email": "Email",
    "label.new_goal": "New Goal",
    "label.participant_survey_parent": "",
    "errors.invalid_email_address": "Invalid email address",
    "pageTitle.new_contact": "New Contact",
    "sidebar.gops": "",
    "button.manage_participants": "Manage Participants",
    "errors.invalid_phone_format": "Invalid phone number",
    "notifications.login_details_have_been_changed": "Login details have been changed",
    "moduleTitle.participant_logs": "Participant's logs",
    "label.save": "Save",
    "label.frequently_asked_questions": "Frequently Asked Questions (FAQs)",
    "label.city": "City",
    "notifications.configuration_value_has_been_reset": "Configuration value has been reset",
    "states.office_sign_off": "Award Office Authorisation",
    "button.save": "Save",
    "button.import_data_from_selected_file": "Import data from selected file",
    "parentalConsent.i_understand_that_the_participant_cannot": "9. I understand that the participant can only  start an Award activity once they have chosen a suitable Assessor for the activity and the activity has been approved by the Award Leader on the Online Record Book as meeting the requirements of the Award.  The Section Assessor is approved by the Award Leader as suitable to assess the activity.  An Award section is complete once the participant has completed the required hours , the Assessor has verified the hours are accurate and the Award Leader has signed off the activity in the Online Record Book.",
    "pageTitle.apiKeys": "",
    "label.international_region": "International Region",
    "tabs.levels": "Levels",
    "tabs.additional_files": "Additional Files",
    "label.continuation_level": "Continuation Level",
    "table.adventurous_journey_detail": "Adventurous Journey Details",
    "button.set": "Set",
    "label.i_certify_that_as_the_assessor": "I certify that as the {role} of this activity that the participant has met the requirements.",
    "table.coordinator": "Coordinator",
    "participant.send_confirmation_email_again": "Send confirmation email again?",
    "table.report": "Report",
    "label.update_translations_results": "",
    "table.observation_note": "Observation Note",
    "label.view_more": "View More",
    "notifications.payment_link_has_been_reset": "Payment link has been reset",
    "table.type": "Type",
    "moduleTitle.updateConfigurationKey": "Update configuration key",
    "sidebar.independent_award_centers": "Independent Award Centres",
    "table.activity_type": "Activity Type",
    "label.awardMode.online": "Online",
    "table.data_state": "",
    "button.generate_report": "Generate Report",
    "moduleTitle.assessed_by_award_leader": "Assessed by Award leader",
    "table.child_protection_number": "Child protection number",
    "button.bulk_change": "",
    "label.send_welcome_email": "",
    "label.award_state": "Award State",
    "moduleTitle.overview": "Overview",
    "table.aj_detail": "Adventurous Journey Detail",
    "pageTitle.tasks_activity_approvals": "Activity Approval",
    "label.section": "Section",
    "route.history": "History",
    "route.event_participants": "Event Participants",
    "participant.account_detail": "Account Settings",
    "route.dashboard": "Dashboard",
    "table.payments": "Payments",
    "pageTitle.profile": "Profile",
    "organisation.remove_organisation": "Remove Organisation",
    "pageTitle.my_organization": "My Organisation",
    "label.award_leader": "Award Leader",
    "notifications.assessor_has_been_updated": "Assessor has been updated",
    "label.participant_personal_reflection": "",
    "button.add_key": "",
    "header.appMotto": "DUKE",
    "table.qualifying": "Qualifying",
    "button.upload": "Upload",
    "button.resend": "Resend",
    "label.filename": "Filename",
    "label.change_parental_consent": "",
    "button.cancel": "Cancel",
    "label.aply_to_all_langs": "",
    "route.customization": "Customisation",
    "errors.minimal_duration_is": "Minimal duration is 30 min",
    "label.email_help_participant_first_name": "",
    "label.participant_status": "Participant Status",
    "award.bronze_level_short": "Bronze",
    "label.phone_type": "Phone Type",
    "global.night": "night",
    "button.adventurous_journey_settings": "Adventurous Journey Settings",
    "participant.leader_must_be_selected": "Leader must be selected",
    "pageTitle.translationsManagement": "",
    "moduleTitle.user_added_preparation_and_training": "User Added Preparation and Training",
    "table.approve": "Approve",
    "label.role_in_organisation": "Role in Organisation",
    "states.finished": "Finished",
    "label.created": "Created",
    "button.back_to_home": "Back to Home",
    "label.options": "Options",
    "contact.next_level_invitation": "Next level invitation",
    "moduleTitle.activity_detail": "Activity Detail",
    "route.section_signoff": "Section Authorisation",
    "moduleTitle.assign_labels_bulk": "",
    "button.contact_settings": "Contact Settings",
    "label.transation_id": "Transaction ID",
    "notifications.activity_has_been_updated": "Activity has been updated",
    "sidebar.awards": "Awards",
    "parentalConsent.images_consent": "As the parent/guardian, I give consent for any images to be used by the Foundation for promotional purposes.",
    "participant.would_you_like_to_delete": "Would you like to delete this account?",
    "roles.user": "User",
    "label.label": "",
    "label.select_sheet": "",
    "global.no_results": "No results",
    "moduleTitle.address_line_2": "Address Second Line",
    "states.awaiting_office_sign_off": "Award Office Authorisation",
    "moduleTitle.export": "Export",
    "moduleTitle.address_line_1": "Address First Line",
    "notifications.participant_has_been_assigned": "Participant has been assigned",
    "roles.viewer": "Viewer",
    "label.participants_total": "Participants total",
    "errors.auth_code_is_no_longer_valid": "Authorisation code is no longer valid - it may have been used or has expired",
    "label.file_is_not_available": "",
    "button.select_template": "Select Template",
    "label.payment": "Payment",
    "award.silver_level_short": "Silver",
    "table.participant_id": "Participant ID",
    "text.hours_old": "",
    "moduleTitle.your_personal_information": "Your Personal Information",
    "aj.minimum_date_recommendation": "Minimum date recommendation for Practice AJ and {name} is",
    "label.date_of_payment": "Date of Payment",
    "button.view": "View",
    "label.create_new_label": "",
    "title.confirmation": "Confirmation",
    "button.set_participants": "Set Participants",
    "roles.assessor": "Assessor",
    "moduleTitle.coordinator_settings": "Coordinator settings",
    "label.parent_relationship": "Parent&#39;s relationship",
    "table.nao": "NAO",
    "notifications.email_has_been_sent": "Email has been sent",
    "label.email_help_participant_full_name": "",
    "sidebar.suboperating_authorities": "Sub-Operating Authorities",
    "route.award": "Award",
    "label.no_roles": "No roles",
    "table.files": "Files",
    "aj.minimum_date_requirements": "Minimum date requirement for Qualifying AJ and {name} is",
    "pageTitle.labels": "",
    "label.participant_is_semi_offline": "Participant is Offline",
    "moduleTitle.other_coordinators": "Other coordinators",
    "button.updateSelectedLanguage": "",
    "tasks.approve_award_registration": "Approve Award Registration",
    "participant.invite_participant_to_next_level": "Invite participant to next level?",
    "label.twitter": "Twitter",
    "pageTitle.awards": "Awards",
    "warning.award_marked_as_paid": "",
    "table.edit": "Review",
    "states.change_to_state_warning_missing_hours_to_complete": "",
    "label.dofe": "International Award",
    "moduleTitle.after_assigning_a_role_to_yourself": "After assigning or changing a role for yourself you'll required to login again.",
    "label.transaction_id": "Transaction ID",
    "table.suboperating_authority": "Sub-Operating Partner",
    "label.participant_survey": "As an Award Participant I am happy to participate in the Foundation's Participant Satisfaction Surveys",
    "label.created_by": "Created by",
    "button.send_confirmation_email_again_question": "Send confirmation email again",
    "label.email_help_award_leader_email": "",
    "label.name": "Name",
    "tabs.gold_level": "Gold Level",
    "pageTitle.award_documents": "Award Documents",
    "label.online_payments": "Online Payments",
    "label.child_protection_number": "Child protection number",
    "participant.send_password_recovery_email": "Send password recovery email?",
    "notifications.new_log_has_been_added": "New log has been added",
    "moduleTitle.add_gop_role": "",
    "label.organization_name": "Organisation Name",
    "pageTitle.my_organization_templates": "My Organisation - Templates",
    "pageTitle.award_leaders": "Award Leaders",
    "label.status": "Status",
    "label.street": "Street",
    "roles.if_staff_superuser": "IF Staff Superuser",
    "table.licence_holder": "Licence Holder",
    "label.created_at": "Created at",
    "table.section": "Section",
    "table.system_rights": "System Rights",
    "label.iac_type": "IAC Type",
    "label.other": "Other",
    "moduleTitle.login": "Login",
    "label.no_data_to_show": "No data to show",
    "aj.cannot_modify_award_level_if_participants_are_assigned": "The Award Level cannot be modified if participants are assigned to the Adventurous Journey",
    "tabs.waiting_payments": "Waiting Payments",
    "global.supervisor": "Supervisor",
    "notifications.new_role_has_been_added": "New role has been added",
    "award.silver_level": "Silver Level",
    "heading.change_awards_mode": "Change Award's mode",
    "button.save_changes": "Save changes",
    "organisation.would_you_like_to_move_award_unit": "Where would you like to remove this organisation?",
    "label.fields": "",
    "label.email_help_organization_name": "",
    "pageTitle.mro_related_detail": "My Region Office - Details",
    "table.started_at": "Started at",
    "parentalConsent.i_consent_to_the_award_unit": "2. I consent to the Award activities being managed under the Award Unit’s Safety Management Plan and Child Protection policies.",
    "logs.minutes": "minutes",
    "label.total_participants": "Total Participants",
    "moduleTitle.contact_info": "Contact Information",
    "table.payment_link": "Payment link",
    "errors.please_contact_your_local_award_staff": "Please contact your local Award Staff."
}